/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1LibrarycodesQueryResponse } from '../../types/GetV1Librarycodes.ts'

export const getV1LibrarycodesQueryKey = () => [{ url: '/v1/LibraryCodes' }] as const

export type GetV1LibrarycodesQueryKey = ReturnType<typeof getV1LibrarycodesQueryKey>

/**
 * {@link /v1/LibraryCodes}
 */
export async function getV1Librarycodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1LibrarycodesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/LibraryCodes`,
        ...requestConfig,
    })
    return res
}

export function getV1LibrarycodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1LibrarycodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1LibrarycodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1LibrarycodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Librarycodes(config)
        },
    })
}

/**
 * {@link /v1/LibraryCodes}
 */
export function useGetV1Librarycodes<
    TData = ResponseConfig<GetV1LibrarycodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1LibrarycodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1LibrarycodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1LibrarycodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1LibrarycodesQueryKey()

    const query = useQuery(
        {
            ...getV1LibrarycodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
